/* cáene — quantity ladder row in the Rebuy Smart Cart (1 → 2 → 3 pouches).
   Shown only when the cart holds a single one-time line of an eligible product at a
   quantity with a next step. Quantity is changed through Rebuy's own cart queue; the
   price comes from the Shopify automatic discounts "60-day ritual" / "90-day ritual"
   and the gift from Rebuy's tiered progress bar (699 kr), so nothing is priced here.
   The prices below are display copy only and must follow those discounts.
   Tracking: a click stamps the cart attribute _qty_upsell (follows the order):
   "<handle>" for step 2, "<handle>_3" for step 3. view/click go to GA4 (gtag) and
   Clarity only with analytics consent, upsell_type qty_2 / qty_3. */
(() => {
  const OFFERS = {
    debloat: {
      1: {title: 'make it a 60-day ritual', body: 'save 15%, free shipping', was: '299', now: '209 kr'},
      2: {unlocked: '60-day ritual unlocked', saved: 'saved 90 kr', title: 'go for 90 days', body: '3rd pouch + desire gummies on us', was: '598', now: '209 kr'}
    }
  };
  const eligible = () => {
    if (window.caeneDebloatWatch) return null;
    const items = window.Rebuy?.Cart?.getItems?.() || [];
    if (items.length !== 1) return null;
    const item = items[0];
    const offer = OFFERS[item.handle]?.[item.quantity];
    if (!offer || item.selling_plan_allocation) return null;
    if (item.properties && Object.keys(item.properties).some((key) => key === '_tier' || key === '_rb_id')) return null;
    return {item, offer, step: item.quantity + 1, key: `${item.handle}:${item.quantity}`};
  };
  const track = (event, handle, step) => {
    try { if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return; } catch (_) { return; }
    if (typeof window.gtag === 'function') window.gtag('event', event, {upsell_product: handle, upsell_type: `qty_${step}`});
    if (typeof window.clarity === 'function') window.clarity('event', event);
  };
  const attach = () => {
    const cart = document.getElementById('rebuy-cart');
    if (!cart || cart.dataset.caeneQtyUpsell) return;
    cart.dataset.caeneQtyUpsell = 'true';
    let busy = false;
    const viewed = new Set();
    // Count a view only once the row is actually on screen (the closed drawer is rendered with visibility:hidden).
    const seen = () => {
      const row = cart.querySelector('.caene-qty-upsell');
      if (!row || viewed.has(row.dataset.key)) return;
      if (!cart.classList.contains('is-visible') || getComputedStyle(row).visibility !== 'visible') return;
      viewed.add(row.dataset.key);
      track('qty_upsell_view', row.dataset.handle, row.dataset.step);
    };
    const sync = () => {
      const current = cart.querySelector('.caene-qty-upsell');
      const match = busy ? null : eligible();
      if (!match) { current?.remove(); return; }
      const progress = cart.querySelector('[data-rebuy-component="progress-bar"]');
      if (!progress || (current && current.dataset.key === match.key)) return;
      current?.remove();
      const row = document.createElement('div');
      row.className = 'caene-qty-upsell';
      Object.assign(row.dataset, {key: match.key, handle: match.item.handle, step: match.step});
      row.innerHTML = '<div class="caene-qty-upsell__text"><p class="caene-qty-upsell__unlocked"></p><p class="caene-qty-upsell__title"></p><p class="caene-qty-upsell__body"></p></div><button type="button" class="caene-qty-upsell__button"><span class="caene-qty-upsell__cta">add to order</span> <s class="caene-qty-upsell__was"></s> <span class="caene-qty-upsell__now"></span></button>';
      if (match.offer.unlocked) {
        row.classList.add('caene-qty-upsell--unlocked');
        const unlocked = row.querySelector('.caene-qty-upsell__unlocked');
        unlocked.textContent = `✓ ${match.offer.unlocked} `;
        const saved = document.createElement('span');
        saved.className = 'caene-qty-upsell__saved';
        saved.textContent = match.offer.saved;
        unlocked.append(saved);
      } else {
        row.querySelector('.caene-qty-upsell__unlocked').remove();
      }
      row.querySelector('.caene-qty-upsell__title').textContent = match.offer.title;
      row.querySelector('.caene-qty-upsell__body').textContent = match.offer.body;
      row.querySelector('.caene-qty-upsell__was').textContent = match.offer.was;
      row.querySelector('.caene-qty-upsell__now').textContent = match.offer.now;
      row.querySelector('.caene-qty-upsell__button').setAttribute('aria-label', `${match.offer.title}, ${match.offer.now} instead of ${match.offer.was} kr`);
      progress.after(row);
      seen();
    };
    cart.addEventListener('click', async (event) => {
      if (!event.target.closest('.caene-qty-upsell__button')) return;
      const match = eligible();
      if (!match) return;
      busy = true;
      sync();
      track('qty_upsell_click', match.item.handle, match.step);
      const value = match.step === 2 ? match.item.handle : `${match.item.handle}_${match.step}`;
      try {
        await fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {_qty_upsell: value}})});
      } catch (_) { /* tracking must never block the quantity change */ }
      window.Rebuy.Cart.setItemQuantity(match.item, match.step);
    });
    document.addEventListener('rebuy:cart.change', () => { busy = false; sync(); });
    document.addEventListener('rebuy:smartcart.show', () => setTimeout(seen, 600));
    new MutationObserver(sync).observe(cart, {subtree: true, childList: true});
    sync();
  };
  document.addEventListener('rebuy:smartcart.ready', attach);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, {once: true});
  attach();
})();
